import { Component, OnInit, ViewEncapsulation, Inject, ViewChild, AfterViewInit, OnDestroy, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseService } from 'app/_helpers/base/base.service';
import { AuthenticationService } from 'app/services';
import { MatTabGroup } from '@angular/material/tabs';
import { startWith, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { map, join } from 'lodash';

@Component({
    selector: 'property-duplications',
    templateUrl: './property-duplications.component.html',
    styleUrls: ['./property-duplications.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PropertyDuplicationsComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {

    @ViewChild(MatTabGroup, { static: true }) matTabGroup: MatTabGroup;

    currentUser: any;
    postData: any = {};
    dataSource: any = [];
    currentLang: string;
    private _unsubscribeAll: Subject<any> = new Subject();
    loader: boolean;
    property: any;
    cadastralNumbers: string;
    currentAgency: any;

    constructor(
        public matDialogRef: MatDialogRef<PropertyDuplicationsComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        public _baseService: BaseService,
        public _authenticationService: AuthenticationService,
        private _translateService: TranslateService,
        private cdRef: ChangeDetectorRef
    ) {
        this.property = this._data;
        this.currentUser = this._authenticationService.currentUserValue;
        this.currentAgency = this._authenticationService.currentAgencyValue;
        this.currentLang = this._translateService.currentLang;
    }

    ngOnInit(): void {
        let cadastralNumbers = [];
        if (
            this.property.private_info_object &&
            this.property.private_info_object[this.currentAgency._id] &&
            this.property.private_info_object[this.currentAgency._id].cadastral_numbers
        ) {
            cadastralNumbers = this.property.private_info_object[this.currentAgency._id].cadastral_numbers;
            cadastralNumbers = map(cadastralNumbers, 'cadastral_number');
            this.cadastralNumbers = join(cadastralNumbers, ' - ');
        }
    }

    getDuplications(): void {
        this.loader = true;
        this._baseService.post(`properties/new-potential-duplications?user=${this.currentUser._id}`, this.postData)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((data) => {
                this.dataSource = data;
                this.loader = false;
            });
    }

    ngAfterViewInit(): void {
        this.matTabGroup.selectedIndexChange
            .pipe(takeUntil(this._unsubscribeAll), startWith(this.matTabGroup.selectedIndex))
            .subscribe((event: number) => {
                this.dataSource = [];
                if (event === 0) {
                    this.postData = { match: 100 };
                }
                if (event === 1) {
                    this.postData = { match: 95 };
                }
                if (event === 2) {
                    this.postData = { match: 75 };
                }
                this.postData.poperty = this._data;
                this.getDuplications();
            });
    }

    ngAfterViewChecked(): void {
        this.cdRef.detectChanges();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

}
